module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "PageHeader"
  }, [_c('div', {
    staticClass: "PageHeader-container"
  }, [_c('div', {
    staticClass: "PageHeader-breadcrumbs"
  }, [(_vm.lock) ? _c('icon', {
    staticClass: "PageHeader-lock",
    attrs: {
      "name": "lock",
      "width": "11px",
      "height": "11px"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.breadcrumbs) ? _c('breadcrumbs', {
    staticClass: "PageHeader-breadcrumbs",
    attrs: {
      "items": _vm.breadcrumbs
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.share) ? _c('share-button', [_c('share-tab')], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e941efb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageHeader.vue
// module id = 769
// module chunks = 1474